import { render, staticRenderFns } from "./AdminUserListPage.vue?vue&type=template&id=f8f35f20&"
import script from "./AdminUserListPage.vue?vue&type=script&lang=ts&"
export * from "./AdminUserListPage.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUserListPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports